var map = {
	"./AnnouncementBar_CloseButton_X.svg": 320,
	"./Facebook_logo.svg": 321,
	"./Film_CloseButton_X.svg": 322,
	"./Film_PlayButton.svg": 323,
	"./Instagram_logo.svg": 324,
	"./Mail.svg": 325,
	"./Menu_CloseButton.svg": 326,
	"./Menu_Hamburger.svg": 327,
	"./Newsletter_Search_Arrow.svg": 328,
	"./NextStory_DownArrow.svg": 329,
	"./Pinterest_logo.svg": 330,
	"./Share_PlusSign.svg": 331,
	"./VIB_Logotype_BW.svg": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;